import {isDev} from "../functions";

export default (
    require('../otherChains/bnb').default.rpcUrls.default.http[0]
    // isDev
    //     ? require('../otherChains/bnb').default.rpcUrls.default.http[0]
    //     : 'https://bnb-mainnet.likwid.fi'
)